module.exports = __webpack_public_path__ + "img/home-v2.ac3c3e35.svg";